import clsx from "clsx";
import React from "react";

import styles from "./DatePicker.module.css";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelInside?: boolean;
}

const DatePicker = (props: Props) => {
  const { label, labelInside, id, ...rest } = props;
  const className = clsx(
    styles.datePicker,
    labelInside && styles["label-inside"],
  );

  return (
    <div className={className}>
      {label && <label htmlFor={id}>{label}</label>}
      <input
        id={id}
        type="date"
        onClick={(e) => (e.target as HTMLInputElement).showPicker?.()}
        {...rest}
      />
    </div>
  );
};

export default DatePicker;
